// eslint-disable-next-line import/no-cycle
import NList from './NList';

export default NList;
